import { SELECT_CLASS } from './selected-class-actions';

const defaultState = null;

/**
 * Selected Class Reducer
 *
 * Consumes SELECT_CLASS action
 *
 * @param {array} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {Selected Class Object} - current selected class object
 */
export default function (state = defaultState, action) {
    if (!action) return state;

    switch (action.type) {
    case SELECT_CLASS:
        return action.payload;
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./containers/overview/selected-class-reducer.js